var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgInfo16 = function SvgInfo16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#info16_svg__clip0_1063_14051)",
    fill: "#222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 15.333C3.956 15.333.667 12.043.667 8 .667 3.956 3.957.667 8 .667c4.044 0 7.333 3.29 7.333 7.333 0 4.044-3.29 7.333-7.333 7.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.333 6h-.666v6h.666V6zM8.333 4h-.666v.667h.666V4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "info16_svg__clip0_1063_14051"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

export default SvgInfo16;